import { InterpolatedTranslatePipe } from '../pipe/interpolated-translate.pipe';
import { Component, computed, input, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { Button } from '../button';
import { Card, CardContainer, CardHeader } from './card';
import { Page } from './page';
import { TopNavigationComponent } from './top-navigation';

// Error codes (query param `error`) that have a dedicated title/message under
// `cas.errorCode.<code>.*`. Any other code falls back to the generic message.
const CODES_WITH_MESSAGE = ['memberDoesNotExist'];

@Component({
  selector: 'cas-unhandled-error',
  imports: [
    Button,
    TopNavigationComponent,
    Card,
    NgbDropdownModule,
    InterpolatedTranslatePipe,
    Page,
    ReactiveFormsModule,
    CardContainer,
    CardHeader,
  ],
  template: `
    <cas-top-navigation
      withMenuToggle="false"
      withProfileInfo="false" />
    <main
      #main
      class="d-flex flex-column w-100 h-100 justify-content-between">
      <cas-page>
        <cas-card-container xxlCols="1">
          <cas-card>
            <cas-card-header
              [name]="titleKey()"
              [description]="descriptionKey()" />
            <footer>
              <cas-button
                (click)="tryAgain()"
                theme="primary-dark">
                {{ 'cas.unhandledErrorPageTryAgainButton' | translate }}
              </cas-button>
            </footer>
          </cas-card>
        </cas-card-container>
      </cas-page>
    </main>
  `,
  styles: `
    :host {
      height: 100vh;
    }
  `,
})
export class UnhandledError implements OnInit {
  error = input<string>();

  protected readonly titleKey = computed(() =>
    CODES_WITH_MESSAGE.includes(this.error() ?? '')
      ? `cas.errorCode.${this.error()}.title`
      : 'cas.unhandledErrorPageTitle',
  );
  protected readonly descriptionKey = computed(() =>
    CODES_WITH_MESSAGE.includes(this.error() ?? '')
      ? `cas.errorCode.${this.error()}.message`
      : 'cas.unhandledErrorPageSubtitle',
  );

  ngOnInit(): void {
    console.error('Unhandled error occurred:', this.error());
  }

  tryAgain() {
    window.location.href = `${window.location.origin}/ui/`;
  }
}
